"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RejectionReason;
(function (RejectionReason) {
    RejectionReason[RejectionReason["NotSeen"] = 0] = "NotSeen";
    RejectionReason[RejectionReason["TypeNotMatchingCharacter"] = 1] = "TypeNotMatchingCharacter";
    RejectionReason[RejectionReason["ExplicitRejection"] = 2] = "ExplicitRejection";
    RejectionReason[RejectionReason["ImplicitRejection"] = 3] = "ImplicitRejection";
})(RejectionReason = exports.RejectionReason || (exports.RejectionReason = {}));
var AcceptanceReason;
(function (AcceptanceReason) {
    AcceptanceReason[AcceptanceReason["ExplicitAccept"] = 0] = "ExplicitAccept";
    AcceptanceReason[AcceptanceReason["TypedEverything"] = 1] = "TypedEverything";
})(AcceptanceReason = exports.AcceptanceReason || (exports.AcceptanceReason = {}));
class SmartComposeInteraction {
    merge(interaction) {
        if (interaction.suggestionRequestTime !== undefined) {
            this.suggestionRequestTime = interaction.suggestionRequestTime;
        }
        if (interaction.initialRenderTime !== undefined) {
            this.initialRenderTime = interaction.initialRenderTime;
        }
        if (interaction.suggestionRejectionTime !== undefined) {
            this.suggestionRejectionTime = interaction.suggestionRejectionTime;
        }
        if (interaction.suggestionAcceptanceTime !== undefined) {
            this.suggestionAcceptanceTime = interaction.suggestionAcceptanceTime;
        }
        if (interaction.totalResponseLatency !== undefined) {
            this.totalResponseLatency = interaction.totalResponseLatency;
        }
        if (interaction.serviceLatency !== undefined) {
            this.serviceLatency = interaction.serviceLatency;
        }
        if (interaction.suggestionReturned !== undefined) {
            this.suggestionReturned = interaction.suggestionReturned;
        }
        if (interaction.suggestionLength !== undefined) {
            this.suggestionLength = interaction.suggestionLength;
        }
        if (interaction.rejectionReason !== undefined) {
            this.rejectionReason = interaction.rejectionReason;
        }
        if (interaction.acceptanceReason !== undefined) {
            this.acceptanceReason = interaction.acceptanceReason;
        }
        if (interaction.numberOfMatchingCharactersTyped !== undefined) {
            this.numberOfMatchingCharactersTyped = interaction.numberOfMatchingCharactersTyped;
        }
        if (interaction.modelversion !== undefined) {
            this.modelversion = interaction.modelversion;
        }
        if (interaction.modelpayload !== undefined) {
            this.modelpayload = interaction.modelpayload;
        }
        if (interaction.suggestionSource !== undefined) {
            this.suggestionSource = interaction.suggestionSource;
        }
        if (interaction.charactersTypedInSessionAtShownTime !== undefined) {
            this.charactersTypedInSessionAtShownTime = interaction.charactersTypedInSessionAtShownTime;
        }
        if (interaction.suggestion !== undefined) {
            this.suggestion = interaction.suggestion;
        }
        if (interaction.acceptedSuggestion !== undefined) {
            this.acceptedSuggestion = interaction.acceptedSuggestion;
        }
        if (interaction.context !== undefined) {
            this.context = interaction.context;
        }
        if (interaction.nonMatchingCharacterTyped !== undefined) {
            this.nonMatchingCharacterTyped = interaction.nonMatchingCharacterTyped;
        }
        if (interaction.charactersTypedAfterRejection !== undefined) {
            this.charactersTypedAfterRejection = interaction.charactersTypedAfterRejection;
        }
        if (interaction.charactersAcceptedAfterRejection !== undefined) {
            this.charactersAcceptedAfterRejection = interaction.charactersAcceptedAfterRejection;
        }
    }
}
exports.SmartComposeInteraction = SmartComposeInteraction;
